import * as React from 'react';
import styled from 'styled-components';
import { Container, Row, Col } from 'react-bootstrap';
import { useStaticQuery, graphql } from 'gatsby';
import LinkComponent from '../../utils/linkComponent';
import footerBanner from '../../images/footerBanner.webp';

const AcknowledgementStyled = styled.div`
	background-color: ${(props) => props.bgColor};
	//margin-bottom: 1rem;

	.sponsorsFooter {
		/* Gradient background from #2e4d8a to #af252d */
		background: linear-gradient(to right, #2e4d8a, #af252d);
	}

	.acknowledgement {
		padding: 0.5em;
		margin-top: 3rem;
	}
	p {
		margin-top: 1rem;
	}

	.FooterText {
		color: var(--neutral_1) !important;
		padding-right: 3em;
	}
	.sizeFooterText {
		font-size: var(--font-size-lg);
	}
	.boldFooterText {
		font-weight: bold;
	}
	.whiteColor {
		color: var(--secondary_6) !important;
	}
	.Container {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		padding: 1em 5em;
		height: 10em;
		display: flex;
		align-items: center;
	}
	.btn {
		font-weight: bold;
		float: right;
		white-space: nowrap;
		width: 100%;
		color: var(--neutral_1);
		font-size: var(--font-size-md);
	}

	.btn-primary:hover {
		color: var(--primary);
	}

	.footerBtn {
		padding-left: 1em;
	}

	// mobile settings
	@media (max-width: 768px) {
		.Container {
			padding: 2em;
		}
		.FooterText {
			padding-right: 0em;
		}
		.Container {
			flex-direction: column;
			padding: 1em 2em;
			height: auto;
		}
	}
`;

export default function Acknowledgement() {
	const data = useStaticQuery(graphql`
		query {
			allStrapiFooter {
				nodes {
					acknowledgement
				}
			}
			allStrapiAsset {
				nodes {
					footer_background_colour
				}
			}
		}
	`);

	const acknowledgementText = data.allStrapiFooter.nodes[0]?.acknowledgement;

	const backgroundColourRaw =
		data.allStrapiAsset.nodes?.[0]?.footer_background_colour;
	const backgroundColour = backgroundColourRaw
		? backgroundColourRaw.startsWith('--')
			? `var(${backgroundColourRaw})`
			: backgroundColourRaw.startsWith('var(')
			? backgroundColourRaw
			: backgroundColourRaw.startsWith('#') ||
			  backgroundColourRaw.startsWith('rgb')
			? backgroundColourRaw
			: `var(--${backgroundColourRaw})`
		: 'var(--neutral_1)';

	// check the page is 'THETA Newsletter' or not
	// remove the register your interest to attend THETA Banner from the registration page
	if (
		typeof window !== 'undefined' &&
		window.location.pathname !== '/registration/'
	) {
		return (
			<AcknowledgementStyled bgColor={backgroundColour}>
				{acknowledgementText ? (
					<div className='acknowledgement'>
						<Container>
							<Row>
								<Col xs={12} md={10} lg={12}>
									<p className='acknowledgementText'>{acknowledgementText}</p>
								</Col>
							</Row>
						</Container>
					</div>
				) : null}

				<div
					style={{
						backgroundImage: `url(${footerBanner})`,
						backgroundSize: 'cover',
					}}
				>
					<div className='Container'>
						<div className='FooterText'>
							<p className='sizeFooterText whiteColor boldFooterText marginTop'>
								Register to attend Stronger Together 2026
							</p>
						</div>
						<div className='footerBtn'>
							<LinkComponent
								to='/registration/'
								onClick={(e) => {
									e.preventDefault(); // Prevent the default link behavior
									window.scrollTo({ top: 0, behavior: 'smooth' }); // Smooth scroll to top
									setTimeout(() => {
										window.location.href = '/registration/'; // Redirect after scrolling
									}, 100); // Adjust timeout as needed
								}}
							>
								{/* <ButtonComponent buttonName='Register'></ButtonComponent> */}
							</LinkComponent>
						</div>
					</div>
				</div>
				{/* <div className='sponsorsFooter'>
				<div className='wrapper'>
					<div className='FooterText'>
						<p className='sizeFooterText boldFooterText'>Sponsors</p>
						<p>
							Promote your organisation at THETA 2025. Take advantage of the
							opportunity to showcase your brand in-front of the sector's
							leading minds and decision makers.
						</p>
					</div>
					<div className='footerBtn marginTop'>
						<ButtonComponent buttonName='Book Now'></ButtonComponent>
					</div>
				</div>
			</div> */}
			</AcknowledgementStyled>
		);
	}
}
